import { render, staticRenderFns } from "./UpdateScheduleLoyaltyDiscount.vue?vue&type=template&id=55f4240b"
import script from "./UpdateScheduleLoyaltyDiscount.vue?vue&type=script&lang=js"
export * from "./UpdateScheduleLoyaltyDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports